import Model from './BaseModel';
import Competition from './Competition';
import EventMarketGroup from './EventMarketGroup';
import collect from 'collect.js';
import { EventStatus } from '@/Constants/Event.js';
import Promotion from '@/Models/Promotion.js';

export default class SportEvent extends Model {
	resourceName() {
		return 'sport_events';
	}

	fields() {
		return [
			'competition',
			'display_result',
			'feed_status',
			'name',
			'number_of_active_markets',
			'participants',
			'override_status',
			'round',
			'sport',
			'start_time',
			'status',
			'suspended',
			'sportcast_fixture_id',
			'outright',
			'is_manual',
			'classification',
			'note'
		];
	}

	computed() {
		return {
			display_status(sport_event) {
				return sport_event.override_status ? sport_event.override_status.name : sport_event.status.name;
			},
			participants(sport_event) {
				return collect(sport_event.participants);
			}
		};
	}

	relationships() {
		return {
			competition: new Competition(),
			event_market_groups: new EventMarketGroup(),
			key_market_group: new EventMarketGroup(),
			promotions: new Promotion()
		};
	}

	cancelEvent() {
		return this.makePersistRequest({
			url: this.selfUrl(),
			method: 'PATCH',
			data: {
				override_status_id: EventStatus.Abandoned
			}
		});
	}

	updatePromotion(data) {
		return this.makePersistRequest({
			url: `${this.resourceUrl()}${this.id}/promotion`,
			method: 'PATCH',
			data
		});
	}

	removePromotion(data) {
		return this.makePersistRequest({
			url: `${this.resourceUrl()}${this.id}/promotion`,
			method: 'DELETE',
			data
		});
	}
}
